module.exports = __webpack_public_path__ + "media/images/admin2/AdminAgenciesGiftReportsIndex__top__form__select-b7e3ade3bdf9f4929fbfd79108126622.svg";